angular.module('impactx.MenuDirectives').directive('ixDeactivateShopView', function() {
    return {
        restrict: 'E',
        controller: 'DeactivateShopViewCtrl',
        controllerAs: 'deactivateShopViewCtrl',
        templateUrl: 'shared/menu/templates/deactivateshopview.tmpl.html'
    }
});